import React from "react";
import RevealText from "../Comman/RevealText";

export default function RoadmapHero() {
  return (
    <>
      <div
        className="tp-hero-3-area tp-hero-3-ptb "
        style={{
          backgroundPosition: "50% 50%",
          backgroundSize: "cover",
          backgroundImage: "url(assets/img/one/roadmap_bg.png)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="tp-hero-3-content-box text-center p-relative">
                <RevealText text="The Journey to Blockchain-Powered Ownership & Entertainment" />

                <span className="tp-hero-3-category tp_reveal_anim">
                  Our roadmap outlines the key milestones as we build the future
                  of blockchain real estate, luxury events, and digital assets.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
